<template>
  <transition name="esocial-modal-fade">
    <div class="esocial-modal-overlay" v-if="showFormList" @click.self="showFormList = false">
      <div class="esocial-modal">
        <div class="esocial-modal__header">
          <span class="esocial-modal__title">Lote {{ parent.formData.lote }}</span>
          <button class="esocial-modal__close" @click="showFormList = false">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="esocial-modal__body">
          <eSocial
            v-if="parent.formData.lote"
            :key="formData.id + '-' + (showForm ? 1 : 0)"
            :layout="parent.formData.layout"
            :lote="parent.formData.lote"
            :avulso="parent.formData.avulso ? parent.formData.avulso : 0"
          ></eSocial>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Rest from "common/rest";
import eSocial from "appsWeb/esocial/index";

export default {
  name: "esocial-lotes-item",
  mixins: [Rest],
  components: { eSocial },
  props: {
    showForm: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  inject: ["formData", "parent"],
  watch: {
    showForm() {
      this.showFormList = !this.showFormList;
    },
  },
  data() {
    return {
      showFormList: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 98%;
  max-width: 98vw;
  max-height: 92vh;
  overflow: hidden;
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?4afd278e